import styled from 'styled-components';

export const TableShell = styled.div`
  .ant-table {
    background: transparent;
  }

  .ant-table-container {
    border: 1px solid rgba(24, 90, 66, 0.08);
    border-radius: 20px !important;
    overflow: hidden;
  }

  .ant-table-thead > tr > th {
    background: linear-gradient(180deg, #f2f8f5 0%, #edf4fb 100%) !important;
    color: #1b4d3d;
    font-size: 0.78rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    border-bottom: 1px solid rgba(24, 90, 66, 0.08) !important;
  }

  .ant-table-tbody > tr > td {
    background: rgba(255, 255, 255, 0.82);
    border-bottom: 1px solid rgba(24, 90, 66, 0.06);
  }

  .ant-table-tbody > tr:hover > td {
    background: rgba(241, 248, 244, 0.95) !important;
  }

  .ant-pagination {
    margin: 18px 4px 0 !important;
  }
`;
